import { Navigate, Outlet } from 'react-router'
import type { JSX } from 'react'
import { ErrorState, FullPageLoading } from '@/ui/states'
import { useTenants } from './context'

/**
 * Everything inside the shell needs an organisation selected on the session.
 *
 * Three outcomes, and each of them is a real state rather than a fallback:
 *
 *  * still loading the list — the whole frame waits, because rendering a
 *    sidebar with no organisation name and then filling it in is a flash;
 *  * the list could not be read — a full-page error with the request id,
 *    since without it there is no shell to show the failure *inside*;
 *  * no organisation selected — `/organisations`, which is where both a brand
 *    new account and someone removed from their last one belong.
 */
export function RequireTenant(): JSX.Element {
  const { status, failure, active, reload } = useTenants()

  if (status === 'loading') return <FullPageLoading label="Loading your organisations" />
  if (status === 'error' && failure) {
    return (
      <div className="app-full-state">
        <ErrorState failure={failure} title="Could not load your organisations" onRetry={reload} />
      </div>
    )
  }
  if (!active) return <Navigate to="/organisations" replace />
  return <Outlet />
}
